import { render, staticRenderFns } from "./ComputerModalForm.vue?vue&type=template&id=78a2d9b6"
import script from "./ComputerModalForm.vue?vue&type=script&lang=js"
export * from "./ComputerModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports